export const DEFAULT_ADDRESS = {
  streetAddress: '1000 S Broadway',
  city: 'Denver',
  state: 'CO',
  zipcode: '80209'
}
